import { combineReducers } from 'redux';
import adminDonationsReducer from './adminDonationsReducer';
import donationOptionsReducer from './donationOptionsReducer';

export default combineReducers({
  entitiesState: adminDonationsReducer,
  donationOptions: donationOptionsReducer,
});
